module.exports = __webpack_public_path__ + "images/xyz2-4cb762b43caee003b850693b509abde8.jpg";